import { type ReactElement } from 'react';
import SolutionPageLayout from '../../components/features/SolutionPageLayout';

export default function Handwerk(): ReactElement {
  return (
    <SolutionPageLayout
      badge="Für Handwerker"
      title="Buchhaltung für Handwerker – vom Angebot bis zur Rechnung"
      subtitle="Konzentrieren Sie sich auf Ihr Handwerk. Saldify kümmert sich um Angebote, Aufträge und Rechnungen – auch von der Baustelle aus."
      heroImage="/screenshots/app-belege.webp"
      heroImageAlt="Belege unterwegs fotografieren und in Saldify erfassen"
      introTitle="Büroarbeit direkt auf der Baustelle erledigen"
      introText="Als Handwerker verbringen Sie Ihre Zeit am liebsten beim Kunden – nicht im Büro. Mit Saldify erstellen Sie Angebote und Rechnungen direkt vor Ort, per Tablet oder Smartphone."
      introBullets={[
        'Angebote beim Kundentermin erstellen',
        'Aufmaß digital erfassen',
        'Rechnung sofort nach Abschluss erstellen',
        'Material- und Lohnkosten sauber trennen',
      ]}
      benefits={[
        {
          title: 'Mobil einsatzbereit',
          description: 'Erstellen Sie Angebote und Rechnungen direkt beim Kunden – auch offline.',
        },
        {
          title: 'Aufmaß & Kalkulation',
          description: 'Digitale Aufmaßerfassung und automatische Kalkulation.',
        },
        {
          title: 'Materialverwaltung',
          description: 'Verwalten Sie Ihren Materialbestand und Einkaufspreise.',
        },
        {
          title: 'Stundenzettel',
          description: 'Erfassen Sie Arbeitszeiten pro Baustelle und Mitarbeiter.',
        },
        {
          title: 'Steuerfreie Leistungen',
          description: '§35a-konforme Rechnungen für haushaltsnahe Dienstleistungen.',
        },
        {
          title: 'Garantie-Verwaltung',
          description: 'Behalten Sie den Überblick über Gewährleistungsfristen.',
        },
      ]}
      useCases={[
        {
          title: 'Elektriker',
          description: 'Elektroinstallationen anbieten, abrechnen und dokumentieren.',
        },
        {
          title: 'Sanitär & Heizung',
          description: 'Wartungsverträge verwalten, Reparaturen abrechnen.',
        },
        {
          title: 'Maler & Lackierer',
          description: 'Flächen berechnen, Materialkosten kalkulieren.',
        },
        {
          title: 'Tischler & Schreiner',
          description: 'Aufträge für Möbel und Einbauten professionell abwickeln.',
        },
      ]}
      features={[
        'Mobile App für Baustelle',
        'Digitales Aufmaß',
        'Angebots- und Auftragsverwaltung',
        'Material- und Lohnkostentrennung',
        'Stundenerfassung pro Projekt',
        '§35a-konforme Rechnungen',
        'Baustellendokumentation',
        'Gewährleistungsverwaltung',
      ]}
      recommendedPlan={{
        name: 'Plus',
        price: '9€/Monat',
        description: 'Für Handwerksbetriebe: Angebote, Aufträge, Mobile App und Kundenverwaltung inklusive.',
      }}
      testimonial={{
        quote: 'Die App ist genau das, was ich als Elektriker brauche. Angebot beim Kunden erstellen, Auftrag bestätigen, Rechnung nach der Arbeit – alles in einer App.',
        author: 'Peter W.',
        role: 'Elektromeister',
        company: 'Elektro Werner',
      }}
    />
  );
}
